import { useCallback } from "react"
import { useToast } from "@hooks"
import { strategiesApi } from "Pages/DsRepricing/Page/@services/api"
import { fromServer } from "Pages/DsRepricing/Page/@services/adapters"
import { dsRepricingListData } from "Pages/DsRepricing/Page/@signals"

/**
 * The list's switch is a boolean over a three-state model: a strategy is
 * `draft` until someone turns it on, then `enabled`, then `disabled` —
 * and `draft` never comes back (PRD 04, brief criterio 26). Turning it
 * on can be refused with a 409 when the strategy overlaps another at the
 * same priority, so the optimistic flip is rolled back with the server's
 * reason, not a generic message.
 */
export default function useDsRepricingStatus(id, name) {
	const { showToast } = useToast()

	const handleStatus = useCallback((newStatus) => {
		const previous = dsRepricingListData.value
		dsRepricingListData.value = previous.map(item =>
			item.id === id
				? { ...item, enabled: newStatus, status: newStatus ? 'enabled' : 'disabled' }
				: item
		)
		strategiesApi.setStatus(id, newStatus ? 'enabled' : 'disabled')
			.then(row => {
				const updated = fromServer(row)
				dsRepricingListData.value = dsRepricingListData.value.map(item =>
					item.id === id ? updated : item
				)
			})
			.catch(err => {
				showToast.error(err?.message || `Error changing the status of '${name}'.`)
				dsRepricingListData.value = previous
			})
	}, [id, name])

	return { handleStatus }
}
